__turbopack_context__.v({
  "admin-bg-danger": "MoreWorks-module-scss-module__2poQeq__admin-bg-danger",
  "admin-bg-info": "MoreWorks-module-scss-module__2poQeq__admin-bg-info",
  "admin-bg-primary": "MoreWorks-module-scss-module__2poQeq__admin-bg-primary",
  "admin-bg-secondary": "MoreWorks-module-scss-module__2poQeq__admin-bg-secondary",
  "admin-bg-success": "MoreWorks-module-scss-module__2poQeq__admin-bg-success",
  "admin-bg-warning": "MoreWorks-module-scss-module__2poQeq__admin-bg-warning",
  "admin-border": "MoreWorks-module-scss-module__2poQeq__admin-border",
  "admin-border-dark": "MoreWorks-module-scss-module__2poQeq__admin-border-dark",
  "admin-border-light": "MoreWorks-module-scss-module__2poQeq__admin-border-light",
  "admin-context": "MoreWorks-module-scss-module__2poQeq__admin-context",
  "admin-rounded": "MoreWorks-module-scss-module__2poQeq__admin-rounded",
  "admin-rounded-full": "MoreWorks-module-scss-module__2poQeq__admin-rounded-full",
  "admin-rounded-lg": "MoreWorks-module-scss-module__2poQeq__admin-rounded-lg",
  "admin-rounded-md": "MoreWorks-module-scss-module__2poQeq__admin-rounded-md",
  "admin-rounded-sm": "MoreWorks-module-scss-module__2poQeq__admin-rounded-sm",
  "admin-shadow-lg": "MoreWorks-module-scss-module__2poQeq__admin-shadow-lg",
  "admin-shadow-md": "MoreWorks-module-scss-module__2poQeq__admin-shadow-md",
  "admin-shadow-sm": "MoreWorks-module-scss-module__2poQeq__admin-shadow-sm",
  "admin-sr-only": "MoreWorks-module-scss-module__2poQeq__admin-sr-only",
  "admin-text-light": "MoreWorks-module-scss-module__2poQeq__admin-text-light",
  "admin-text-muted": "MoreWorks-module-scss-module__2poQeq__admin-text-muted",
  "admin-text-primary": "MoreWorks-module-scss-module__2poQeq__admin-text-primary",
  "admin-text-secondary": "MoreWorks-module-scss-module__2poQeq__admin-text-secondary",
  "more-works": "MoreWorks-module-scss-module__2poQeq__more-works",
  "more-works__card": "MoreWorks-module-scss-module__2poQeq__more-works__card",
  "more-works__card-content": "MoreWorks-module-scss-module__2poQeq__more-works__card-content",
  "more-works__card-date": "MoreWorks-module-scss-module__2poQeq__more-works__card-date",
  "more-works__card-image": "MoreWorks-module-scss-module__2poQeq__more-works__card-image",
  "more-works__card-img": "MoreWorks-module-scss-module__2poQeq__more-works__card-img",
  "more-works__card-meta": "MoreWorks-module-scss-module__2poQeq__more-works__card-meta",
  "more-works__card-placeholder": "MoreWorks-module-scss-module__2poQeq__more-works__card-placeholder",
  "more-works__card-subtitle": "MoreWorks-module-scss-module__2poQeq__more-works__card-subtitle",
  "more-works__card-title": "MoreWorks-module-scss-module__2poQeq__more-works__card-title",
  "more-works__container": "MoreWorks-module-scss-module__2poQeq__more-works__container",
  "more-works__error": "MoreWorks-module-scss-module__2poQeq__more-works__error",
  "more-works__grid": "MoreWorks-module-scss-module__2poQeq__more-works__grid",
  "more-works__loading": "MoreWorks-module-scss-module__2poQeq__more-works__loading",
  "more-works__spinner": "MoreWorks-module-scss-module__2poQeq__more-works__spinner",
  "more-works__title": "MoreWorks-module-scss-module__2poQeq__more-works__title",
  "spin": "MoreWorks-module-scss-module__2poQeq__spin",
});
